import { all } from "@redux-saga/core/effects";
import { fork } from "@redux-saga/core/effects";
import * as Auth from "../Reducers/Auth/saga";
import * as Categories from "../Reducers/Categories/saga";
import * as Images from "../Reducers/Images/saga";
import * as Requests from "../Reducers/Requests/saga";
import * as Templates from "../Reducers/Templates/saga";
import * as Banners from "../Reducers/Banners/saga";
import * as Settings from "../Reducers/Settings/saga";

export function* rootSaga() {
  const AuthRoots = [
    // Authentications
    fork(Auth.login),
    fork(Auth.logout),

    // Categories
    fork(Categories.categories),
    fork(Categories.single_category),
    fork(Categories.addCat),
    fork(Categories.editCat),
    fork(Categories.hideCat),
    fork(Categories.unhideCat),
    fork(Categories.deleteCat),
    fork(Categories.addNewAttribute),
    fork(Categories.editAttribute),
    fork(Categories.appendAttributeValues),
    fork(Categories.createProgressMonitor),
    fork(Categories.getProgressMonitor),

    // Images
    fork(Images.get_images),
    fork(Images.add_images),
    // Requests
    fork(Requests.requests),
    fork(Requests.resREQ),
    fork(Requests.single_request),
    //Templates
    fork(Templates.createTemplatesList),
    fork(Templates.categoriesByID),
    fork(Templates.templatesList),
    fork(Templates.delTemplate),
    fork(Templates.updateTemplatesList),

    //Banners
    fork(Banners.GetBannersCards),
    fork(Banners.create_Banner),
    fork(Banners.delBanners),
    fork(Banners.updateBannersCards),

    // Delivery
    fork(Settings.get_shifts_in_city),
    fork(Settings.create_shifts_in_city),
    fork(Settings.update_shifts_in_city),
    fork(Settings.un_register_shift),
    fork(Settings.get_cities_saga),
    fork(Settings.update_city_saga),
    fork(Settings.get_towns_saga),
    fork(Settings.update_town_saga),

    fork(Settings.add_city_saga),
    fork(Settings.add_town_saga),
    fork(Settings.delete_city_saga),
    fork(Settings.delete_town_saga),
  ];
  yield all([...AuthRoots]);
}
